/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum LoanType {
  Mortgage = 'Mortgage',
  Auto = 'Auto',
  Personal = 'Personal',
  CreditCard = 'Credit Card',
  Purchase = 'Purchase',
  Refinance = 'Refinance',
  HomeEquityLoan = 'HomeEquityLoan',
  HELOC = 'Home Equity Line of Credit',
  HelocType = 'Heloc',
  HomeImprovement = 'Home Improvement',
  HomeEquityLoan2 = 'Home Equity Loan',
  ManufacturedHome = 'Manufactured Home',
  OAO = 'OAO',
  OLA = 'OLA',
  Secured = 'Secured',
  PersonalLineOfCredit = 'Personal Line of Credit',
  Boat = 'Boat',
  BoatDirect = 'Boat Direct',
  RV = 'RV',
  RVDirect = 'RV Direct',
  Motorcycle = 'Motorcycle',
  MotorcycleDirect = 'Motorcycle Direct',
  SportUtilityTrailer = 'Sport Utility Trailer',
  UnsecuredLoan = 'Unsecured Loan',
  UnsecuredLineOfCredit = 'Unsecured Line of Credit',
  AutoDirect = 'Auto Direct',
  AutoLease = 'Auto Lease',
  AutoEquity = 'Auto Equity',
  Automotive = 'Automotive',
  AutoNonRegisteredVehicles = 'Non-registered Vehicles'
}

export enum LoansStatus {
  Approved = 'approved',
  Approve = 'approve',
  Funded = 'funded',
  Pending = 'pending',
  Counter = 'counter offered',
  ContactYourLender = 'Please Contact Us',
  Declined = 'declined',
  Withdrawn = 'withdrawn',
  Conditionally = 'Conditionally Pre-Approved',
  PreApproved = 'Pre-Approved',
  ConditionallyApproved = 'Conditionally Approved'
}

export enum DecisionStatus {
  Approved = 'approved',
  Approve = 'approve',
  Refer = 'refer',
  Declined = 'declined',
  Decline = 'decline',
  Pending = 'pending',
  Counter = 'counter offered',
  Withdrawn = 'withdrawn',
  Submitted = 'submitted',
  InProgress = 'in progress',
  StatusInProgress = 'status in progress',
  UnderReview = 'under review',
  Processing = 'processing'
}

/** loan purpose list */
export enum LoanPurposeTypes {
  Purchase = 'Purchase',
  ConstructionOnlyB600 = 'ConstructionOnlyB600',
  Refinance = 'Refinance',
  ConstructionToPermanent = 'ConstructionToPermanent',
  Other = 'Other',
  Unknown = 'Unknown',
  RefinanceRateandTerm = 'RefinanceRateandTerm',
  RefinanceCashOut = 'RefinanceCashOut',
  HomeEquityLoan = 'HomeEquityLoan',
  HELOC = 'HELOC',
  StandAlone = 'Standalone'
}
/** TaskType for document page */
export enum TaskType {
  Upload = 'upload',
  Esign = 'esign',
  Read = 'read',
  Review = 'review',
  Ach = 'ach',
  Payoff = 'payoff',
  Address = 'address',
  Payment = 'payment',
  RateLock = 'ratelock'
}
/** ApplicationStage for Overview page */
export enum ApplicationStage {
  Application = 'Application',
  Verification = 'Verification',
  Approval = 'Approval',
  Closing = 'Closing',
  Funded = 'Funded',
  Migrated = 'Migrated',
  PreAppSubmitted = 'PreAppSubmitted',
  AppSubmitted = 'AppSubmitted',
  ConditionalApproval = 'ConditionalApproval',
  FinalApproval = 'FinalApproval',
  IncompleteApp = 'IncompleteApp',
  CounterOffer = 'CounterOffer',
  Declined = 'Declined',
  Withdrawn = 'Withdrawn'
}

/** ApplicationState for Overview page */
export enum ApplicationState {
  OnTrack = 'on track',
  UnderReview = 'under review',
  CounterOffered = 'counter offered',
  Approved = 'approved',
  ConditionallyApproved = 'conditionally approved',
  ReadyToFund = 'ready to fund',
  Funded = 'funded',
  Pending = 'pending',
  AtRisk = 'at risk',
  ContactYourLender = 'contact your lender',
  Withdrawn = 'withdrawn',
  Declined = 'please contact us',
  InProgress = 'Application In Progress'
}

/** LoanStatus Color for Loan Details page */
// Delete after migrating to new dasboard
export enum LoanStatusCss {
  OnTrack = 'bl-font-color--success',
  UnderReview = 'bl-font-color--success',
  Approved = 'bl-font-color--success',
  ConditionallyApproved = 'bl-font-color--success',
  CounterOffered = 'bl-font-color--success',
  ReadyToFund = 'bl-font-color--success',
  Funded = 'bl-font-color--success',
  Pending = 'bl-font-color--slate',
  AtRisk = 'bl-font-color--warning',
  ContactYourLender = 'bl-font-color--warning',
  Withdrawn = 'bl-font-color--slate',
  IncompleteApp = 'bl-font-color--warning',
  Declined = 'bl-font-color--warning',
  OverviewWithdrawn = 'bl-font-color--error',
  OverviewPending = 'bl-font-color--warning'
}

/** LoanStatus theme for Loan Details page */
export enum LoanStatusThemeCss {
  Pending = 'warning-theme',
  Approved = 'success-theme',
  CounterOffered = 'success-theme',
  Withdrawn = 'error-theme',
  Declined = 'warning-theme'
}

/** DecisionStatus theme for Account Opening Dashboard page */
// Can delete after new dashboard is turned on
export enum DecisionStatusThemeCss {
  Pending = 'warning-theme',
  Approved = 'success-theme',
  CounterOffered = 'success-theme',
  Withdrawn = 'error-theme',
  Submitted = 'warning-theme',
  InProgress = 'warning-theme',
  Declined = 'warning-theme'
}

/** ApplicationStateCss for Overview page */
export enum ApplicationStateCss {
  StageCompleted = 'stage-completed',
  StageRisk = 'stage-risk',
  StageContact = 'stage-contact',
  StageWithdrawn_Expired = 'stage-withdrawn_or_expired',
  StageDeclined = 'stage-declined',
  StageReview = 'stage-review'
}
/** Doccument status types */
export enum DocumentStatus {
  Todo = 'todo',
  New = 'new',
  Inreview = 'inreview',
  Done = 'done',
  Completed = 'completed',
  Waived = 'waived',
  All = 'all',
  SignComplete = 'signcomplete',
  Declined = 'declined'
}
/** status types for activity page */
export enum ActivityStatus {
  Rejected = 'rejected',
  Comment = 'comment'
}
/** types for payment */
export enum PaymentType {
  creditCard = 'creditcard',
  ach = 'ach'
}
/** types for property */
export enum PropertyType {
  Refinance = 'Refinance',
  Purchasing = 'Purchasing Property'
}
/** gender types */
export enum Gender {
  Male = 'Male',
  Female = 'Female'
}
/** AccountType types */
export enum AccountType {
  Checking = 'checking',
  Saving = 'saving',
  SavingsShareAccount = 'savingsshareaccount',
  OnlineBanking = 'onlinebanking',
  OverdraftProtection = 'overdraftprotection',
  Retirement = 'retirement',
  Other = 'other',
  MembershipServices = 'membershipservices',
  ShareCertificates = 'sharecertificates',
  RetireShareCertificates = 'retiresharecertificates',
  AtmService = 'atm/debit card'
}
/** AddressType types */
export enum AddressType {
  HomeAddress = 'HomeAddress',
  CurrentAddress = 'CurrentAddress',
  MailingAddress = 'MailingAddress'
}

/** Oao application status */
export enum OAOAppStatus {
  InProgress = 'In Progress',
  Submitted = 'Submitted',
  Pending = 'Pending',
  Approved = 'Approved'
}

/** PricingType types */
export enum PricingType {
  VA = 'VA',
  FHA = 'FHA'
}

export enum ReferenceType {
  ESigned = 1
}
/** Amortization types */
export enum AmortizationTypes {
  Fixed = 'Fixed',
  GraduatedPaymentMortgageGPM = 'GraduatedPaymentMortgageGPM',
  AdjustableRate = 'AdjustableRate',
  OtherAmortizationType = 'OtherAmortizationType',
  Balloon = 'Balloon',
  Buydown = 'Buydown',
  DailySimpleInterest = 'DailySimpleInterest',
  GraduatedPaymentARM = 'GraduatedPaymentARM',
  GrowingEquityMortgage = 'GrowingEquityMortgage',
  RateImprovementMortgage = 'RateImprovementMortgage',
  ReverseMortgage = 'ReverseMortgage',
  Ruleof78s = 'Ruleof78s',
  Step = 'Step',
  Conventional = 'Conventional',
  StartUp = 'StartUp',
  ARM = 'ARM'
}
/** OAO Membership Types */
export enum OaoMembershipTypes {
  Business = 'Business',
  Youth = 'Youth',
  Personal = 'Personal'
}
/** Dynamic Application Flow */
export enum DynamicFlow {
  OAO = 'Oao',
  Mortgage = 'Mortgage',
  Consumer = 'Consumer',
  Auto = 'Auto'
}
/** OAO Funding Types */
export enum OAOFundingType {
  ACH = 1,
  CreditDebitCard = 4
}
/** OAO Funding Types */
export enum OAOPaymentVendor {
  SWBC = 'SWBC',
  ICG = 'ICG',
  NONE = 'NONE'
}

/** OAO Funding ACH Account Type */
export enum OAOFundingACHAccountType {
  None = 0,
  Checking = 1,
  Savings = 2
}

/** OAO Funding Card Type (SWBC) */
export enum OAOFundingCardType {
  None = 0,
  Visa = 1,
  MasterCard = 2,
  Discover = 3,
  AmericanExpress = 4
}

/** Identification Type */
export enum IdentificationType {
  Unknown = 1,
  KnownExistingMember = 2,
  DriversLicense = 3,
  StateIDCard = 4,
  USPassport = 5,
  Passport = 6,
  MilitaryIDCard = 7,
  ForeignGovernmentIssuedID = 8,
  PermanentResidentCard = 9,
  TribalID = 10,
  ForeignDriversLicense = 11,
  WorkAuthorizationCard = 12,
  StudentID = 13,
  EmployeeID = 14,
  AlumniID = 15,
  BirthCertificate = 16,
  HealthInsuranceCard = 17,
  LandingCard = 18,
  CertificateofIndianStatus = 19,
  Minor = 20,
  MexicoMatriculaConsularCard = 21,
  GuatemalanConsularCard = 22,
  VeteransAffairVACard = 23,
  SocialSecurityBenefitVerificationLetter = 24,
  MedicareCard = 25,
  CreditDebitCard = 26,
  CurrentBankStatement = 27,
  CurrentCreditCardStatement = 28,
  CurrentLoanStatement = 29,
  CurrentPaystub = 30,
  CurrentUtilityBill = 31,
  ExpiredIDDriverLicense = 32,
  MediCalCard = 33,
  MedicaidCard = 34,
  RealEstateTaxBill = 35,
  SocialSecurityCard = 36,
  VoterRegistrationCard = 37
}

/** OAO Applicant Type */
export enum OAOApplicantType {
  Primary = 1,
  CoApplicant = 2,
  Borrower3 = 3,
  Borrower4 = 4
}

/** OAO Source Applicant Type */
export enum OAOSourceApplicantType {
  Personal = 1,
  ResponsibleParty = 2,
  BeneficialOwner = 3,
  AuthorizedSigners = 4
}

/** OAO Application Status */
export enum ApplicationStatusType {
  New = 1,
  Processing = 2,
  Counter = 3,
  Decline = 4,
  Approve = 5,
  Refer = 6,
  Incomplete = 7,
  Exception = 8,
  Withdraw = 9
}

export enum ApplicationStageType {
  EnterApp = 1,
  AppSubmitted = 2,
  ProcessingError = 3,
  SystemDecision = 4,
  ManualDecision = 5,
  Pending = 6,
  Funding = 7,
  Funded = 8,
  Withdraw = 9,
  PreApproval = 10,
  ManualReview = 11,
  PIDCheck = 12
}

/** OAO Application Funding Status */
export enum ApplicationFundingStatusType {
  Saved = 1,
  Approved = 2,
  Pending = 3,
  Failed = 4,
  Initiated = 5
}

/** Funding Type */
export enum MemberAccountDisbursementType {
  ACH = 1,
  Cash = 2,
  Check = 3,
  CreditDebitCard = 4,
  Transfer = 5,
  Other = 6
}

/** Dynamic Application Flow */
export enum IncomeFrequency {
  Yearly = 'Yearly',
  Monthly = 'Monthly',
  BiWeekly = 'Bi-Weekly',
  Weekly = 'Weekly',
  Hourly = 'Hourly'
}

/** Payment Vendor Type */
export enum PaymentVendorType {
  SWBC = 1,
  ICG = 2
}

export enum EsignMessage {
  oneCoApp = 'oneCoApp',
  moreThanOneCoApp = 'moreThanOneCoApp',
  oneCoAppNotSigned = 'oneCoAppNotSigned',
  moreThanOneCoAppNotSigned = 'moreThanOneCoAppNotSigned',
  singleApplicant = 'singleApplicant'
}

export enum ContactType {
  Phone = 'Phone',
  Email = 'Email',
  Url = 'URL'
}

/**
 * Enum to determine the Login type of the User with no apps in Dashboard
 */
export enum NoAppsLoginType {
  CellPhone = 'cell phone',
  EmailAddress = 'email address'
}

/**
 * Enum used to send authtype: phone or email in URL params to login
 */
export enum AuthType {
  Phone = 'phone',
  Email = 'email'
}

/**
 * Enum used to determine the Phone Type selected by the User
 */
export enum PhoneType {
  Mobile = 'Mobile',
  HomePhone = 'HomePhone'
}
